import tools from "../../../../helpers/tools";
import CheckList from "./CheckList";
import CompanyRecapWrapper from "./CompanyRecapWrapper";
import CompanyTopRecap from "./CompanyTopRecap";
import InputDisplay from "./InputDisplay";
import activites from "./activities.json";
import { Link } from "react-router-dom";

const RCPROBlocks = ({ company, clientId }) => {
  return (
    <CompanyRecapWrapper>
      <CompanyTopRecap company={company} product="RCPRO" />
      <div className="mt-3">
        <CheckList
          items={[
            {
              text: (
                <>
                  Description Activités :{" "}
                  <InputDisplay
                    inputName="activitesPro"
                    inputType="text"
                    inputValue={company.activitesPro
                      .map((codeActivite) => {
                        const found = activites.find(
                          (a) => a.id == codeActivite
                        );
                        return found ? found.name : "";
                      })
                      .filter((name) => name !== "")
                      .join(", ")}
                  />
                </>
              ),
            },
            {
              text: (
                <>
                  Chiffre d'Affaires :{" "}
                  <InputDisplay
                    inputName="turnover"
                    inputType="text"
                    inputValue={
                      <>{tools.truenumberWithSpaces(company.turnover)} €</>
                    }
                  />
                </>
              ),
            },
            {
              text: (
                <>
                  Appel à des sous-traitants :{" "}
                  <InputDisplay
                    inputName="appelSousTraitants"
                    inputType="btnList"
                    inputValue={company.appelSousTraitants}
                  />
                </>
              ),
            },
            {
              text: (
                <>
                  Assuré en RC Pro actuellement :{" "}
                  <InputDisplay
                    inputName="possedeUneRC"
                    inputType="btnList"
                    inputValue={company.possedeUneRC}
                  />
                </>
              ),
            },
            {
              text: (
                <>
                  Date de naissance du dirigeant :{" "}
                  <InputDisplay
                    inputName="dateNaissanceDirigeant"
                    inputType="date"
                    inputValue={company.dateNaissanceDirigeant}
                  />
                </>
              ),
            },
          ]}
        />
        <div className="d-center">
          <Link
            to={`/modify-answers/${clientId}/RCPRO/${company.establishmentId}/${company.quotationId}`}
            className="btn btn-link pt-3 pb-4"
            style={{ fontWeight: "400", fontSize: 16 }}
          >
            Modifier mes réponses
          </Link>
        </div>
      </div>
    </CompanyRecapWrapper>
  );
};

export default RCPROBlocks;
